/**
 * @file Generic form Textarea component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  size: PropTypes.oneOf(['md', 'sm']),
  rows: PropTypes.number,
  error: PropTypes.bool,
};

const Textarea = ({
  id,
  className,
  placeholder,
  inputRef,
  size,
  rows,
  error,
  ...props
}) => {
  const classes = classNames({
    'form-control': true,
    'form-control-sm': size === 'sm',
    'form-control-error': !!error,
    [className]: !!className,
  });

  return (
    <textarea
      id={id}
      className={classes}
      placeholder={placeholder}
      ref={inputRef}
      rows={rows}
      {...props}
    />
  );
};

Textarea.propTypes = propTypes;

export default Textarea;
